<template>
  <textarea
    :rows="rows"
    class="block w-full rounded-md shadow-sm disabled:opacity-50 dark:bg-gray-900 dark:text-white dark:placeholder-gray-300 sm:text-sm"
    :class="classes"
    v-model="value"
    ref="input"
  ></textarea>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: String,
  },
  error: {
    default: null,
  },
  rows: {
    default: 3,
  },
})

const emit = defineEmits(['update:modelValue'])

const value = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})

const classes = computed(() =>
  props.error
    ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
    : 'border-gray-300 dark:border-gray-700 focus:ring-indigo-500 focus:border-indigo-500'
)
</script>
